import { AbstractScheduler } from './abstract.scheduler';
export class DelayedIntervalScheduler extends AbstractScheduler {
  schedule(callback) {
    const delay = this.state.completedCount === 0 ? DelayedIntervalScheduler.DEFAULT_INITIAL_DELAY : DelayedIntervalScheduler.DEFAULT_INTERVAL;
    const timerId = setTimeout(callback, delay);
    return () => clearTimeout(timerId);
  }
}
DelayedIntervalScheduler.DEFAULT_INTERVAL = 500;
DelayedIntervalScheduler.DEFAULT_INITIAL_DELAY = 1500;